import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationGrowththroughEmpathy(props) {
  return (
    <svg
      viewBox="0 0 104 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M98.75 100.001c0-25.889-20.986-46.876-46.874-46.876C25.987 53.125 5 74.112 5 100.001"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M16.704 100.001c0-19.416 15.74-35.171 35.172-35.171 19.43 0 35.171 15.74 35.171 35.171"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M28.213 100.001c0-13.07 10.593-23.648 23.648-23.648 13.054 0 23.662 10.579 23.662 23.648"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M39.736 100c0-6.692 5.432-12.124 12.124-12.124 6.693 0 12.124 5.432 12.124 12.124M5 0c0 25.889 20.987 46.875 46.875 46.875C77.764 46.875 98.751 25.89 98.751 0"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M87.047 0c0 19.416-15.74 35.171-35.172 35.171-19.43 0-35.171-15.74-35.171-35.171"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M75.538 0c0 13.07-10.593 23.648-23.648 23.648-13.054 0-23.662-10.579-23.662-23.648"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M64.015 0c0 6.693-5.432 12.124-12.124 12.124S39.767 6.693 39.767.002"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
    </svg>
  );
}

export default IllustrationGrowththroughEmpathy;
